import { defineSlotRecipe } from '@chakra-ui/react';

export const mobileNumberInputSlotRecipe = defineSlotRecipe({
    slots: ['button', 'input'],
    base: {
        button: {
            minH: 8,
            minW: 8,
            colorPalette: 'secondary',
        },
        input: {
            textAlign: 'center',
            w: '3rem',
            p: 2,
            borderBottomWidth: '1px',

            // _focusVisible: {
            //     boxShadow: 'none',
            //     outlineWidth: 0,
            // },
        },
    },
});
